require("./style.css");
import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import SiteDateSelector from "../SiteDateSelector";
import isUndefined from "lodash/isUndefined";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import map from "lodash/map";
import find from "lodash/find";
import Dialog from "material-ui/Dialog";
import RadioButton from "material-ui/RadioButton/RadioButton";
import RadioButtonGroup from "material-ui/RadioButton/RadioButtonGroup";
import SegmentHousehold from "./SegmentHouseHold";
import HighestOpportunityAudience from "./HighestOpportunityAudience";
import moment from "moment-timezone/moment-timezone";
const pdfConverter = require("jspdf");
const html2canvas = require("html2canvas");
import { FullRow, Row, Col } from "../../framework/Grid";
import Checkbox from "material-ui/Checkbox";
import queryString from "querystring";
import {
  _getSegmentDistributeCsv,
  _getDeviceDistributeCsv,
  _getCultureCsv,
} from "./pdfHelper";
import SegmentDetailReport from "./SegmentDetailReport";
import SegmentDeviceReport from "./SegmentDeviceReport";
import SegmentCultureReport from "./SegmentCultureReport";
import {
  getUrlParameterByName,
  pdfReportHeaderDataUri,
  pdfReportFooterDataUri,
  getTextSize,
  getDayRangeTitle,
  downLoadCSVFunc,
  addPdfFont,
  splitNumber,
} from "../../../utils/utility";
import sortBy from "lodash/sortBy";
import { AlertError } from "material-ui/svg-icons";
import CheckCircle from "material-ui/svg-icons/action/check-circle";
import { TextField } from "material-ui";
import Select from "react-select";

import HeatMap from "../HeatMap";
class SegmentDistribution extends AcquireWebComponent {
  constructor(props) {
    super(props);
    const type =
      window.localStorage.getItem("__segmentSysId__") ||
      (getUrlParameterByName("type")
        ? getUrlParameterByName("type")
        : "default");
    const segmentTop = window.localStorage.getItem("__segmentTop__");
    const granularity = window.localStorage.getItem("__granularity__");
    this.state = {
      type: type,
      openContactUs: false,
      showSuccessForm: false,
      ppType: "detail",
      subject: "",
      comments: "",
      showDownloadDialog: false,
      onPdfReportDownload: false,
      disabledBtnDownload: false,
      segmentTop: segmentTop ? +segmentTop : 5,
      printMode: false,
      showEmptyError: false,
      showCreateAudienceDialog: false,
      audienceType: "scale",
      audienceName: "",
      granularity: granularity || "scale", // Precision or Scale
      measure:
        window.localStorage.getItem("__segmentMeasure__") ||
        (getUrlParameterByName("measure") &&
        (getUrlParameterByName("measure") === "hh" ||
          getUrlParameterByName("measure") === "index")
          ? getUrlParameterByName("measure")
          : "hh"),
    };
    props.setGranularity(granularity);
  }
  submitContactRequest(e) {
    e.preventDefault();
    let oriPage = "";
    const type = getUrlParameterByName("type");
    const source = getUrlParameterByName("source");
    const isHeatMap = Boolean(getUrlParameterByName("heatmap"));
    const { segmentDistributionSystems } = this.props;

    const system = find(segmentDistributionSystems, (s) => {
      return parseInt(s.id, 10) === parseInt(type, 10);
    });
    if (system) oriPage = system.name;

    if (source) {
      oriPage =
        source === "pop"
          ? oriPage + " Most Popular Page"
          : oriPage + " Favorite Page";
      if (isHeatMap) {
        oriPage += " : Geographic Traffic Page";
      }
      const page = getUrlParameterByName("page");
      if (page) {
        oriPage += " : " + page;
      }
    } else {
      if (isHeatMap) {
        oriPage += " Geographic Traffic Page";
      } else {
        oriPage =
          this.state.ppType === "detail"
            ? oriPage + " Segment Details Page"
            : oriPage + " Device Details Page";
      }
    }
    const postData = {
      clientId: this.props.selected_client,
      subject: this.state.subject.trim(),
      comment: this.state.comments.trim(),
      originationPage: oriPage,
    };
    this.props.sendAssistRequest(postData);
  }
  componentWillUnmount() {
    this.props.clearCreateScaleAudienceInfo();
    this.props.clearCreateVisitorsAudienceInfo();
    this.setState({
      showCreateAudienceDialog: false,
      audienceName: "",
    });
  }
  componentDidMount() {
    const tagId = this.getTagId();
    const clientId = parseInt(getUrlParameterByName("cid"), 10);
    const type = getUrlParameterByName("type");
    const heatmap = getUrlParameterByName("heatmap");
    const page = getUrlParameterByName("page");
    if (
      heatmap &&
      this.props.segmentDistributionHouseHold &&
      this.props.dayRange
    ) {
      this.getDistributionData(
        tagId,
        page,
        this.props.segmentDistributionHouseHold,
        this.props.dayRange,
        "heatmap",
      );
    }
    if (getUrlParameterByName("type")) {
      this.setState({
        type: getUrlParameterByName("type"),
      });
    }
    if (tagId > 0 && clientId > 0) {
      this.props.getClientSites(clientId);
      this.props.setWebsiteId(tagId);
      this.props.selectClient(clientId);
      this.props.getSegmentDistributionSystems(tagId, () => {
        this.getSegmentDistributionData(tagId, type, this.props.dayRange);
      });
    } else if (clientId > 0 && isEmpty(tagId)) {
      this.props.getClientSites(clientId);
      this.props.getClientTags(clientId);
      this.props.selectClient(clientId);
      if (this.props.websiteId) {
        // const url =
        //   "/segment-distribution?cid=" +
        //   clientId +
        //   "&tag=" +
        //   this.props.websiteId +
        //   "&type=" +
        //   this.state.type;
        // window.location.href = url;
        this.props.getSegmentDistributionSystems(
          this.props.websiteId,
          (segmentDistributionSystems) => {
            const nowType = this.state.type;
            let has = false;
            segmentDistributionSystems &&
              segmentDistributionSystems.forEach((it) => {
                if (Number(nowType) === Number(it.id)) {
                  has = true;
                }
              });
            const url =
              "/segment-distribution?cid=" +
              clientId +
              "&tag=" +
              this.props.websiteId +
              "&type=" +
              (has && nowType ? nowType : segmentDistributionSystems[0].id);
            window.location.href = url;
          },
        );
      }
    } else {
      this.props.selectClient(this.props.selected_client);
    }
  }
  changeMeasure(val) {
    const tagId = this.getTagId();
    window.localStorage.setItem("__segmentMeasure__", val);
    this.setState({ measure: val }, () => {
      const page = getUrlParameterByName("page");
      this.getDistributionData(
        tagId,
        page,
        this.props.segmentDistributionHouseHold,
        this.props.dayRange,
        "culture",
      );
      // this.getCultureReport(
      //   tagId,
      //   page,
      //   this.props.segmentDistributionHouseHold,
      //   this.props.dayRange,
      // );

      this.updateDistributionData(
        tagId,
        this.state.type,
        this.props.dayRange,
        this.props.segmentDistributionHouseHold,
      );
    });
  }
  changeTopCount(val) {
    const tagId = this.getTagId();
    // window.__segmentTop__ = val;
    window.localStorage.setItem("__segmentTop__", val);
    this.setState({ segmentTop: val }, () => {
      this.updateDistributionData(
        tagId,
        this.state.type,
        this.props.dayRange,
        this.props.segmentDistributionHouseHold,
      );
      const page = getUrlParameterByName("page");
      this.getDistributionData(
        tagId,
        page,
        this.props.segmentDistributionHouseHold,
        this.props.dayRange,
        "culture",
      );
    });
  }
  componentWillReceiveProps(nextProps) {
    const clientId = parseInt(getUrlParameterByName("cid"), 10);
    const tagId = this.getTagId();
    const type = getUrlParameterByName("type");
    const page = getUrlParameterByName("page");
    const pageChange = !!page !== !!this.hasPage;
    if (nextProps.client_info) {
      if (nextProps.client_info.subscriptionTierId < 4) {
        this.props.history.push("/");
      }
    }

    this.hasPage = !!page;
    if (!this.props.websiteId && nextProps.websiteId) {
      this.props.getSegmentDistributionSystems(
        nextProps.websiteId,
        (segmentDistributionSystems) => {
          const nowType = this.state.type;
          let has = false;
          segmentDistributionSystems &&
            segmentDistributionSystems.forEach((it) => {
              if (Number(nowType) === Number(it.id)) {
                has = true;
              }
            });
          const url =
            "/segment-distribution?cid=" +
            clientId +
            "&tag=" +
            nextProps.websiteId +
            "&type=" +
            (has && nowType ? nowType : segmentDistributionSystems[0].id);
          window.location.href = url;
        },
      );
    }
    if (nextProps.selected_client !== this.props.selected_client) {
      if (
        nextProps.selected_client !== clientId &&
        nextProps.selected_client > 1
      ) {
        window.location.href =
          "/segment-distribution?cid=" + nextProps.selected_client;
      }
      this.props.getClientInfo(nextProps.selected_client);
      this.props.getClientTags(nextProps.selected_client);
    }
    if (
      nextProps.request_assist_successful === true &&
      isUndefined(this.props.request_assist_successful)
    ) {
      this.setState({
        subject: undefined,
        comments: undefined,
        showSuccessForm: true,
        openContactUs: false,
      });
    }

    if (isUndefined(nextProps.websiteId) && tagId > 0) {
      this.props.setWebsiteId(tagId);
    }
    if (
      (nextProps.dayRange !== this.props.dayRange && tagId) ||
      (pageChange && tagId) ||
      (nextProps.granularity !== this.props.granularity && tagId)
    ) {
      this.setState({
        showEmptyError: false,
      });
      this.getSegmentDistributionData(
        tagId,
        this.state.type,
        nextProps.dayRange,
        page,
      );
    }

    if (
      (!isEqual(
        nextProps.segmentDistributionHouseHold,
        this.props.segmentDistributionHouseHold,
      ) &&
        nextProps.segmentDistributionHouseHold) ||
      (pageChange && nextProps.segmentDistributionHouseHold)
    ) {
      this.updateDistributionData(
        tagId,
        this.state.type,
        nextProps.dayRange,
        nextProps.segmentDistributionHouseHold,
      );
      this.getDistributionData(
        tagId,
        page,
        nextProps.segmentDistributionHouseHold,
        nextProps.dayRange,
        "culture",
      );
    }
    if (
      Boolean(nextProps.loadingDistributionDetailReport) !==
      Boolean(this.props.loadingDistributionDetailReport)
    ) {
      if (
        !nextProps.loadingDistributionDetailReport &&
        this.props.loadingDistributionDetailReport
      ) {
        this.setState({
          showEmptyError:
            !nextProps.segmentDistributionHouseHold ||
            isEmpty(nextProps.segmentDistributionHouseHold.distributions),
        });
      } else {
        this.setState({
          showEmptyError: false,
        });
      }
    }
    if (nextProps.location.search !== this.props.location.search) {
      this.updateDistributionData(
        tagId,
        this.state.type,
        nextProps.dayRange,
        nextProps.segmentDistributionHouseHold,
      );
    }
    if (
      !isEqual(
        nextProps.segmentDistributionSystems,
        this.props.segmentDistributionSystems,
      )
    ) {
      if (type === "default" && nextProps.segmentDistributionSystems) {
        let url =
          "/segment-distribution?cid=" +
          nextProps.selected_client +
          "&tagId=" +
          tagId +
          "&type=" +
          nextProps.segmentDistributionSystems[0].id;
        if (page) {
          url += "&page=" + page;
        }
        const source = getUrlParameterByName("source");
        if (source) {
          url += "&source=" + source;
        }
        this.props.history.push(url);
      }
    }
  }

  getTagId() {
    return getUrlParameterByName("tag")
      ? parseInt(getUrlParameterByName("tag"), 10)
      : parseInt(getUrlParameterByName("tagId"), 10);
  }

  getDistributionData(
    tagid,
    page,
    segmentDistributionHouseHold,
    dayRange,
    reportType,
  ) {
    const granularity = this.props.granularity
      ? this.props.granularity
      : this.state.granularity;
    //getCultureReport(tagId, page, segmentDistributionHouseHold, dayRange) {
    segmentDistributionHouseHold =
      segmentDistributionHouseHold || this.props.segmentDistributionHouseHold;
    dayRange = dayRange || this.props.dayRange;
    const segmentIds = map(
      sortBy(segmentDistributionHouseHold.distributions, (d) => {
        if (this.state.measure === "index") return d.segmentIndex;
        else
          return (
            d.householdVisitors /
            segmentDistributionHouseHold.totalHouseholdVisitors
          );
      }),
      "segmentCode",
    )
      .reverse()
      .slice(0, this.state.segmentTop)
      .join(",");
    const type = getUrlParameterByName("type") || this.state.type;
    if (reportType === "culture")
      this.props.getCultureCodeReport(
        tagid || this.getTagId(),
        type,
        dayRange,
        segmentIds,
        page || getUrlParameterByName("page"),
        granularity,
      );
    if (reportType === "heatmap")
      this.props.getDistributionHeatMapData(
        tagid || this.getTagId(),
        type,
        dayRange,
        segmentIds,
        page || getUrlParameterByName("page"),
        granularity,
      );
  }

  getSegmentDistributionData(tagId, type, period) {
    const { websiteId, dayRange, granularity } = this.props;
    const tag_id = tagId ? tagId : websiteId;
    const day_range = period ? period : dayRange;
    const page = getUrlParameterByName("page");
    if (type === "default") {
      if (this.props.segmentDistributionSystems) {
        type = this.props.segmentDistributionSystems[0].id;
      }
    }
    this.props.getSegmentDistribution(
      tag_id,
      type,
      day_range,
      granularity ? granularity : this.state.granularity,
      page,
    );
  }

  updateDistributionData(tagId, type, period, segmentDistributionHouseHold) {
    const { websiteId, dayRange } = this.props;
    const granularity = this.props.granularity
      ? this.props.granularity
      : this.state.granularity;
    const tag_id = tagId ? tagId : websiteId;
    const day_range = period ? period : dayRange;
    const page = getUrlParameterByName("page");
    if (type === "default") {
      if (this.props.segmentDistributionSystems) {
        type = this.props.segmentDistributionSystems[0].id;
      }
    }
    const heatmap = getUrlParameterByName("heatmap");

    if (this.state.segmentTop === 0 || !segmentDistributionHouseHold) {
      this.props.getSegmentReportTop5OS(
        tag_id,
        type,
        day_range,
        undefined,
        granularity,
        page,
      );
      this.props.getSegmentDistributionDetailReport(
        tag_id,
        type,
        day_range,
        undefined,
        page,
        granularity,
      );
      this.props.getSegmentDistributionDeviceModelReport(
        tag_id,
        type,
        day_range,
        undefined,
        granularity,
        page,
      );
      this.props.getSegmentDistributionDeviceTypeReport(
        tag_id,
        type,
        day_range,
        undefined,
        granularity,
        page,
      );
      if (heatmap) {
        this.props.getDistributionHeatMapData(
          tag_id,
          type,
          day_range,
          undefined,
          page,
          granularity,
        );
      }
    } else {
      const data = segmentDistributionHouseHold.distributions;
      const segmentIds = map(
        sortBy(data, (d) => {
          if (this.state.measure === "index") return d.segmentIndex;
          else
            return (
              d.householdVisitors /
              segmentDistributionHouseHold.totalHouseholdVisitors
            );
        }),
        "segmentCode",
      )
        .reverse()
        .slice(0, this.state.segmentTop)
        .join(",");
      this.props.getSegmentReportTop5OS(
        tag_id,
        type,
        day_range,
        segmentIds,
        granularity,
        page,
      );
      this.props.getSegmentDistributionDetailReport(
        tag_id,
        type,
        day_range,
        segmentIds,
        page,
        granularity,
      );
      this.props.getSegmentDistributionDeviceModelReport(
        tag_id,
        type,
        day_range,
        segmentIds,
        granularity,
        page,
      );
      this.props.getSegmentDistributionDeviceTypeReport(
        tag_id,
        type,
        day_range,
        segmentIds,
        granularity,
        page,
      );
      if (heatmap) {
        this.props.getDistributionHeatMapData(
          tag_id,
          type,
          day_range,
          segmentIds,
          page,
          granularity,
        );
      }
    }
  }

  _addPdfHeader(pdf, client_name, bu_name) {
    pdf.setFillColor(127, 127, 127);
    pdf.rect(0, 15, 210, 10, "F");

    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(9);
    pdf.setFontType("bold");
    pdf.addImage(pdfReportHeaderDataUri(), "PNG", 10.5, 3, 60, 0);
    pdf.text(198, 8, moment().format("MMMM DD, YYYY"), null, null, "right");

    pdf.setTextColor(255, 255, 255);
    pdf.setFontType("bold");
    pdf.text(12, 21, "Client:");
    //const lenClientName = getTextSize(client_name.trim(), 'helvetica')
    pdf.setFontType("normal");
    pdf.text(26, 21, client_name ? client_name.trim() : "");
    //cm to inches
    let start = 90; //46 + lenClientName.width * 0.3937 + 0.4
    if (!isEmpty(bu_name)) {
      pdf.setFontType("bold");
      pdf.text(start, 21, "Business Unit:");
      start += 26.5;
      pdf.setFontType("normal");
      pdf.text(start, 21, bu_name ? bu_name.trim() : "");
    }
    pdf.setFillColor(255);
    start = 12;
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(10);
    //pdf.text(12, 30, "Campaigns  >  " + campaignDetail.name);
  }

  _addPdfFooter(pdf, pageHeight) {
    pdf.setFillColor(127, 127, 127);
    const top = pageHeight - 12;
    pdf.rect(0, top, 210, 15, "F");
    pdf.addImage(pdfReportFooterDataUri(), "PNG", 15, top + 3, 20, 0);
    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(9);
    pdf.setFontType("bold");
    pdf.text(
      65,
      top + 6,
      "Copyright © " +
        moment().format("YYYY") +
        " Claritas, LLC. All rights reserved",
    );
  }
  fileName(type) {
    const { client_tags, websiteId, dayRange } = this.props;
    const page = getUrlParameterByName("page");

    const tag = client_tags
      ? client_tags.find((it) => it.id === websiteId)
      : null;
    const domain = tag && tag.domain ? tag.domain : "Unknown";
    const dayRangeTitle = getDayRangeTitle(dayRange).replace(/\s+/g, "");
    const time = moment().format("YYYYMMDD");
    return page
      ? `${domain}_${page}_${dayRangeTitle}_${type}_${time}`
      : `${domain}_${dayRangeTitle}_${type}_${time}`;
  }

  handlePdfDownload() {
    this.setState({
      onPdfReportDownload: true,
      showDownloadDialog: false,
    });
    const {
      clients,
      client_info,
      websiteId,
      dayRange,
      client_sites,
    } = this.props;

    const { type, ppType, measure, segmentTop } = this.state;
    const page = getUrlParameterByName("page");
    const measureTitle = measure === "hh" ? "HH_Visitors" : "Index";
    let reportType = "PRIZM Premier";
    const { segmentDistributionSystems } = this.props;
    const system = find(segmentDistributionSystems, (s) => {
      return parseInt(s.id, 10) === parseInt(type, 10);
    });
    if (system) reportType = system.name;

    const deviceType = ppType === "detail" ? "Segments" : "Devices";

    let client_name = client_info.name;
    let bu_name = "";
    if (client_info.parentClientId) {
      const parent_client = find(clients, (c) => {
        return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
      });
      if (parent_client) {
        client_name = parent_client.name;
        bu_name = client_info.name;
      }
    }
    const s = client_sites.find(function (site) {
      return site.value === websiteId;
    });
    /*
    let pdfFileName =
      s && s.label
        ? s.label +
          "_" +
          getDayRangeTitle(dayRange) +
          "_" +
          reportType +
          "_" +
          measureTitle +
          "_"
        : "Unknown_" +
          getDayRangeTitle(dayRange) +
          "_" +
          reportType +
          "_" +
          measureTitle +
          "_";
    if (page) {
      pdfFileName += page + "-";
    }
    pdfFileName += moment().format("YYYYMMDD") + ".pdf";*/
    const pdfFileName = this.fileName(reportType + "-" + measureTitle) + ".pdf";
    const chartXTitle = document.getElementById("chart-x-title");
    chartXTitle && (chartXTitle.style.display = "block");
    const el_left_nav = document.getElementById("left-nav");
    const el_contact_div = document.getElementById("contact-div");
    const el_report_main = document.getElementById("report-main");
    const el_segment_household_container = document.getElementsByClassName(
      "segment-household-nav-container",
    )[0];
    const el_segment_household_pdf_container = document.getElementsByClassName(
      "sgemnt-household-pdf-nav",
    )[0];
    const el_top_navigator = document.getElementsByClassName(
      "top-navigator",
    )[0];
    const segment_detail_container = document.getElementsByClassName(
      "segment-detail-container",
    )[0];
    const device_report_container = document.getElementById(
      "device-report-container",
    );
    const segment_culture_container = document.getElementsByClassName(
      "segment-culture-report",
    )[0];
    const extra_print_container = document.getElementsByClassName(
      "pdf-extra-container",
    );
    const hidden_print_container = document.getElementsByClassName(
      "pdf-hidden-container",
    );
    const highest_audience_container = document.getElementsByClassName(
      "hightest-audience-list",
    )[0];
    if (segmentTop === 0) {
      highest_audience_container.style.height = "auto";
    }
    for (var i = 0; i < extra_print_container.length; i++) {
      extra_print_container[i].style.display = "block";
    }
    for (var i = 0; i < hidden_print_container.length; i++) {
      hidden_print_container[i].style.display = "none";
    }
    const origin_segment_container_display =
      segment_detail_container.style.display;
    const origin_device_container_display =
      device_report_container.style.display;
    const origin_segment_culture_container_display =
      segment_culture_container.style.display;
    device_report_container.style.display = "flex";
    segment_detail_container.style.display = "flex";
    segment_culture_container.style.display = "flex";
    const pageHeight =
      ppType === "detail"
        ? el_report_main.offsetHeight / (el_report_main.offsetWidth / 205)
        : el_report_main.offsetHeight / (el_report_main.offsetWidth / 213);
    const pdf = new pdfConverter("p", "mm", [210, pageHeight]);
    addPdfFont(pdf);
    pdf.setFont("Helvetica");
    pdf.setFontType("normal");
    pdf.setFontSize(9);
    const pageWidth = 186;
    document.getElementsByClassName("prizm-premier-inactive")[0].style.display =
      "none";
    el_report_main.style.flex = "0 1";
    el_left_nav.style.display = "none";
    el_contact_div.style.display = "none";
    el_segment_household_pdf_container.style.display = "flex";
    el_segment_household_container.style.display = "none";
    el_top_navigator.style.display = "none";
    //el_report_main.style.width = "1024px";
    let mainCanvas = null;
    let isMainCanvas = false;
    setTimeout(function () {
      html2canvas(el_report_main, { logging: false }).then(function (canvas) {
        mainCanvas = canvas;
        isMainCanvas = true;
        el_left_nav.style.display = "block";
        el_contact_div.style.display = "block";
        document.getElementsByClassName(
          "prizm-premier-inactive",
        )[0].style.display = "block";
        el_report_main.style.flex = "1 0";
        el_segment_household_pdf_container.style.display = "none";
        el_segment_household_container.style.display = "flex";
        el_top_navigator.style.display = "flex";
        device_report_container.style.display = origin_device_container_display;
        segment_detail_container.style.display = origin_segment_container_display;
        segment_culture_container.style.display = origin_segment_culture_container_display;
        if (segmentTop === 0) {
          highest_audience_container.style.height = "650px";
        }
        for (var i = 0; i < extra_print_container.length; i++) {
          extra_print_container[i].style.display = "none";
        }
        for (var i = 0; i < hidden_print_container.length; i++) {
          hidden_print_container[i].style.display = "block";
        }
      });
    }, 2000);
    let top = 32;
    const left = 12;
    let intervalId = setInterval(
      function () {
        if (isMainCanvas === false) {
          console.log("PDF Generating...");
        } else {
          clearInterval(intervalId);
          setTimeout(
            function () {
              this._addPdfHeader(pdf, client_name, bu_name);
              let start = left;
              pdf.setFontType("bold");
              pdf.text(start, top, "WEBSITE NAME:");
              start += 30;
              pdf.setFontType("normal");
              pdf.text(start, top, s && s.label ? s.label.trim() : "");
              start +=
                s && s.label
                  ? getTextSize(s.label.trim(), "helvetica").width * 0.3937 +
                    0.4
                  : 1;
              pdf.setFontType("bold");
              pdf.text(start, top, "Date:");
              pdf.setFontType("normal");
              start += getTextSize("Date:", "helvetica").width * 0.3937 + 0.4;
              pdf.text(start, top, getDayRangeTitle(dayRange));
              pdf.setFillColor(221, 245, 243);
              top += 5;
              pdf.rect(left, top, 185, 10, "F");
              pdf.setFontType("bold");
              pdf.setFontSize(11);
              if (page) {
                pdf.setFontSize(9);
                pdf.text(15, top + 6, page);
                pdf.setFontSize(10);
                pdf.setFont("Proxima-Nova");
                // pdf.setFontType("normal");
                // if (ppType === "detail")
                pdf.text(
                  195,
                  top + 6,
                  reportType + " Segment Distribution",
                  null,
                  null,
                  "right",
                );
                // else
                //   pdf.text(
                //     195,
                //     top + 6,
                //     reportType + " Segment Distribution", //  - Device Details",
                //     null,
                //     null,
                //     "right",
                //   );
                pdf.setFontSize(11);
              } else {
                pdf.setFont("Proxima-Nova");
                // pdf.setFontType("normal");
                // if (ppType === "detail")
                pdf.text(15, top + 6, reportType + " Segment Distribution");
                // else
                //   pdf.text(
                //     15,
                //     top + 6,
                //     reportType + " Segment Distribution", //  - Device Details",
                //   );
              }
              pdf.setFont("Helvetica");
              pdf.setFontType("normal");
              pdf.setFontSize(10);
              top += 10;
              pdf.addImage(
                mainCanvas.toDataURL(),
                "PNG",
                left,
                top,
                pageWidth,
                0,
              );

              this._addPdfFooter(pdf, pageHeight);

              pdf.save(pdfFileName.replace(/ /g, "_"));
              chartXTitle && (chartXTitle.style.display = "none");
              this.setState({ onPdfReportDownload: false });
            }.bind(this),
            100,
          );
        }
      }.bind(this),
      50,
    );
  }
  handleCsvDownload() {
    this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
    const page = getUrlParameterByName("page");
    const {
      clients,
      client_info,
      websiteId,
      dayRange,
      client_sites,
      cultureCodeReport,
    } = this.props;
    const { type, ppType, measure } = this.state;
    const measureTitle = measure === "hh" ? "HH_Visitors" : "Index";
    let reportType = "PRIZM Premier";
    const { segmentDistributionSystems } = this.props;
    const system = find(segmentDistributionSystems, (s) => {
      return parseInt(s.id, 10) === parseInt(type, 10);
    });
    if (system) reportType = system.name;

    const deviceType = ppType === "detail" ? "Segments" : "Devices";
    let client_name = client_info.name;
    let bu_name = "";
    if (client_info.parentClientId) {
      const parent_client = find(clients, (c) => {
        return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
      });
      if (parent_client) {
        client_name = parent_client.name;
        bu_name = client_info.name;
      }
    }
    const hhDataSet = [];
    const { segmentDistributionHouseHold } = this.props;
    map(segmentDistributionHouseHold.distributions, (dist) => {
      measure === "hh"
        ? hhDataSet.push({
            segmentCode: dist.segmentCode,
            segmentName: dist.segmentName,
            householdPect: dist.householdPercentage,
            vistorPect:
              dist.householdVisitors /
              segmentDistributionHouseHold.totalHouseholdVisitors,
          })
        : hhDataSet.push({
            segmentCode: dist.segmentCode,
            segmentName: dist.segmentName,
            householdPect: dist.householdPercentage,
            vistorPect:
              dist.householdVisitors /
              segmentDistributionHouseHold.totalHouseholdVisitors,
            segmentIndex: dist.segmentIndex,
          });
    });
    const sortedDS =
      measure === "hh"
        ? sortBy(hhDataSet, (d) => {
            return d.vistorPect;
          }).reverse()
        : sortBy(hhDataSet, (d) => {
            return d.segmentIndex;
          }).reverse();
    const s = client_sites.find(function (site) {
      return site.value === websiteId;
    });
    let csvFileName =
      s && s.label
        ? s.label +
          "_" +
          getDayRangeTitle(dayRange) +
          "_" +
          reportType +
          "_" +
          measureTitle +
          "_"
        : "Unknown_" +
          getDayRangeTitle(dayRange) +
          "_" +
          reportType +
          "_" +
          measureTitle +
          "_";
    if (page) {
      csvFileName += page + "-";
    }
    csvFileName += moment().format("YYYYMMDD");
    let title_line = "Report Details,\r\n";
    /*
    let report_name_line =
      ppType === "detail"
        ? s.label + " " + reportType + " Segment Distribution Report"
        : s.label + " " + reportType + " Device Insights Report";*/
    let report_name_line =
      s.label + " " + reportType + " Segment Distribution Report";

    report_name_line += ",\r\n";
    let report_date_line = "Date," + moment().format("MM/DD/YY") + ",\r\n";
    let client_name_line = "Client Name," + client_name + ",\r\n";
    let bu_name_line = isEmpty(bu_name)
      ? ""
      : "Business Name," + bu_name + ",\r\n";
    let date_filter_line =
      "Campaign Date Filter," + getDayRangeTitle(dayRange) + ",\r\n";
    let page_name_line = page ? "Page, " + page + ",\r\n" : "";
    let measure_line =
      measure == "hh"
        ? "Measure, Household Visitors,\r\n\r\n"
        : "Measure, Index,\r\n\r\n";
    let total_households_matched_line =
      "Total U.S Households Matched to " +
      reportType +
      " Segments" +
      /*deviceType +*/
      "," +
      this.props.segmentDistributionHouseHold.totalHouseholdVisitors +
      ",\r\n\r\n";
    let highest_oppo_audience_line =
      measure === "hh"
        ? "Highest Opportunity Audiences,,\r\nCode,Segment Name,Segment % of U.S Households,% of HH Visitors\r\n"
        : "Highest Opportunity Audiences,,\r\nCode,Segment Name,Segment % of U.S Households,% of HH Visitors,Index\r\n";
    const segment_visitors_arr = [];
    let hhPect = 0;
    let vistPect = 0;
    map(sortedDS, (dist) => {
      hhPect += dist.householdPect;
      vistPect += dist.vistorPect;
      let str =
        dist.segmentCode +
        ',"' +
        dist.segmentName +
        '",' +
        dist.householdPect.toLocaleString(undefined, {
          style: "percent",
          minimumFractionDigits: 2,
        }) +
        "," +
        dist.vistorPect.toLocaleString(undefined, {
          style: "percent",
          minimumFractionDigits: 2,
        }) +
        ",";
      if (measure !== "hh") {
        str += dist.segmentIndex + ",";
      }
      str += "\r\n";
      segment_visitors_arr.push(str);
    });
    if (vistPect > 0) {
      let totalStr =
        "Total,," +
        hhPect.toLocaleString(undefined, {
          style: "percent",
          minimumFractionDigits: 2,
        }) +
        "," +
        vistPect.toLocaleString(undefined, {
          style: "percent",
          minimumFractionDigits: 2,
        }) +
        ",";
      if (measure !== "hh") {
        totalStr += parseInt((vistPect / hhPect) * 100, 10);
        totalStr += ",";
      }
      totalStr += "\r\n";
      segment_visitors_arr.push(totalStr);
    }

    const { props } = this;
    let resultString =
      title_line +
      report_name_line +
      report_date_line +
      client_name_line +
      bu_name_line +
      date_filter_line +
      page_name_line +
      measure_line +
      total_households_matched_line +
      highest_oppo_audience_line +
      segment_visitors_arr.join("");
    const granularity = this.props.granularity
      ? this.props.granularity
      : this.state.granularity;
    resultString +=
      "\r\n\r\nGranularity," +
      granularity.charAt(0).toUpperCase() +
      granularity.slice(1) +
      "\r\n\r\n";
    resultString += _getSegmentDistributeCsv(props, this.state.segmentTop);
    resultString += "\r\n\r\nDevice Insights,\r\n";
    resultString += _getDeviceDistributeCsv(props, this.state.segmentTop);
    resultString += "\r\n\r\nCulture Codes,\r\n";
    resultString += _getCultureCsv(props);
    downLoadCSVFunc(
      resultString,
      csvFileName.replace(new RegExp(" ", "g"), "_"),
    );
    setTimeout(
      function () {
        this.setState({ onCsvReportDownload: false });
      }.bind(this),
      2000,
    );
  }
  cbPDFChange(e, isInputChecked) {
    const result = !this.refs.cbCSV.state.switched && !isInputChecked;
    this.setState({ disabledBtnDownload: result });
  }

  cbCSVChange(e, isInputChecked) {
    const result = !this.refs.cbPDF.state.switched && !isInputChecked;
    this.setState({ disabledBtnDownload: result });
  }

  downloadCsvReport() {
    this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
    this.handleCsvDownload();
  }

  downloadPdfReport() {
    this.setState({ onPdfReportDownload: true, showDownloadDialog: false });
    this.handlePdfDownload();
  }
  handleDownload(e) {
    e.preventDefault();

    if (this.refs.cbPDF.state.switched) {
      this.downloadPdfReport();
    }

    if (this.refs.cbCSV.state.switched) {
      this.downloadCsvReport();
    }
  }
  getTabTitleContent(tabType, topCountTitle) {
    const { segmentDistributionSystems } = this.props;
    const type =
      this.state.type === "default"
        ? getUrlParameterByName("type")
        : this.state.type;
    const system = find(segmentDistributionSystems, (s) => {
      return parseInt(s.id, 10) === parseInt(type, 10);
    });
    if (system) {
      const sysType = system.name;
      const arr = sysType.split(" ");
      if (arr.length > 0 && arr[0] !== "Purple") {
        return (
          <span>
            {topCountTitle} {arr[0]}
            <i className="symbol symbol-tm" /> {arr[1]} {tabType} Details
          </span>
        );
      } else {
        return (
          <span>
            {topCountTitle} {sysType}
            <i className="symbol symbol-tm" /> {tabType} Details
          </span>
        );
      }
    }
    return <span>{topCountTitle} Details</span>;

    switch (this.state.type) {
      case "prizm_premier":
        return (
          <span>
            {topCountTitle} PRIZM Premier
            <i className="symbol symbol-tm" /> {tabType} Details
          </span>
        );
      case "psycle_premier":
        return (
          <span>
            {topCountTitle} P$YCLE Premier
            <i className="symbol symbol-tm" /> {tabType} Details
          </span>
        );
      default:
        return (
          <span>
            {topCountTitle} ConneXions
            <i className="symbol symbol-tm" /> {tabType} Details
          </span>
        );
    }
  }
  showPageNavigation(urlParams) {
    const page = getUrlParameterByName("page");
    const tagId = this.getTagId();
    const cid = parseInt(getUrlParameterByName("cid"), 10);
    const type = getUrlParameterByName("type");
    const source = getUrlParameterByName("source");
    const heatmap = getUrlParameterByName("heatmap");

    if (page) {
      return (
        <div className="pt-20" style={{ fontSize: "16px" }}>
          <div>
            <span
              className="nav-clickable"
              onClick={() => {
                {
                  /*window.location.href = type
                  ? "/segment-distribution?tag=" +
                    tagId +
                    "&cid=" +
                    cid +
                    "&type=" +
                    type
                  : "/segment-distribution?tag=" + tagId + "&cid=" + cid;*/
                }
                this.props.history.push(
                  type
                    ? "/segment-distribution?tag=" +
                        tagId +
                        "&cid=" +
                        cid +
                        "&type=" +
                        type
                    : "/segment-distribution?tag=" + tagId + "&cid=" + cid,
                );
              }}
            >
              Segment Distribution
            </span>
            <span style={{ margin: "0 15px" }}>
              <strong>></strong>
            </span>
            <span
              className="nav-clickable"
              onClick={() => {
                this.props.history.push(
                  source === "fav"
                    ? "/distribution/pages/favorite?cid=" +
                        cid +
                        "&tag=" +
                        tagId +
                        "&type=" +
                        type
                    : "/distribution/pages/popular?cid=" +
                        cid +
                        "&tag=" +
                        tagId +
                        "&type=" +
                        type,
                );
              }}
            >
              {source === "fav" ? "Favorite Pages" : "Most Popular Page"}
            </span>
            <span style={{ margin: "0 15px" }}>></span>
            {heatmap && [
              <span
                className="nav-clickable"
                onClick={() => {
                  delete urlParams["heatmap"];
                  this.props.history.push(
                    (
                      "/segment-distribution" + queryString.stringify(urlParams)
                    ).replace("%3F", "?"),
                  );
                }}
              >
                {page}
              </span>,
              <span style={{ margin: "0 15px" }}>></span>,
              <span>Top states on map</span>,
            ]}
          </div>
          <div
            style={{
              padding: "15px 20px",
              marginTop: "20px",
              background: "#BAE7FF",
            }}
          >
            <strong>{page}</strong>
          </div>
          <div className="light-grey-border-bottom">&nbsp;</div>
        </div>
      );
    } else if (heatmap) {
      return (
        <div className="pt-20" style={{ fontSize: "16px" }}>
          <div>
            <span
              className="nav-clickable"
              onClick={() => {
                {
                  /*window.location.href = type
                ? "/segment-distribution?tag=" +
                  tagId +
                  "&cid=" +
                  cid +
                  "&type=" +
                  type
                : "/segment-distribution?tag=" + tagId + "&cid=" + cid;*/
                }
                this.props.history.push(
                  type
                    ? "/segment-distribution?tag=" +
                        tagId +
                        "&cid=" +
                        cid +
                        "&type=" +
                        type
                    : "/segment-distribution?tag=" + tagId + "&cid=" + cid,
                );
              }}
            >
              Segment Distribution
            </span>
            <span style={{ margin: "0 15px" }}>
              <strong>></strong>
            </span>
            <span>Top states on map</span>
          </div>
        </div>
      );
    }
  }
  saveAudience() {
    const tagId = this.getTagId();
    console.log('props.granularity = ' + this.props.granularity);
    console.log('state.granularity = ' + this.state.granularity);
    const granularity = this.props.granularity || this.state.granularity;
    const { segmentDistributionHouseHold } = this.props;
    const page = getUrlParameterByName("page");

    if (this.state.segmentTop === 0 || !segmentDistributionHouseHold) {
      if (this.state.audienceType === "scale") {
        this.props.createScaleAudience(
          this.state.audienceName,
          tagId,
          this.state.type,
          this.props.dayRange,
          [],
        );
      } else {
        this.props.createVisitorAudience(
          this.state.audienceName,
          tagId,
          this.state.type,
          this.props.dayRange,
          [],
          granularity,
          page,
        );
      }
    } else {
      const data = segmentDistributionHouseHold.distributions;
      const segmentIds = map(
        sortBy(data, (d) => {
          if (this.state.measure === "index") return d.segmentIndex;
          else
            return (
              d.householdVisitors /
              segmentDistributionHouseHold.totalHouseholdVisitors
            );
        }),
        "segmentCode",
      )
        .reverse()
        .slice(0, this.state.segmentTop)
        .join(",");
      if (this.state.audienceType === "scale") {
        this.props.createScaleAudience(
          this.state.audienceName,
          tagId,
          this.state.type,
          this.props.dayRange,
          segmentIds,
        );
      } else {
        this.props.createVisitorAudience(
          this.state.audienceName,
          tagId,
          this.state.type,
          this.props.dayRange,
          segmentIds,
          granularity,
          page,
        );
      }
    }
  }
  onWebSiteIdChanged(id) {
    const clientId = parseInt(getUrlParameterByName("cid"), 10);
    this.props.setWebsiteId(id);
    this.props.getSegmentDistributionSystems(
      id,
      (segmentDistributionSystems) => {
        const type =
          segmentDistributionSystems && segmentDistributionSystems[0]
            ? segmentDistributionSystems[0].id
            : this.state.type;
        const url =
          "/segment-distribution?cid=" +
          clientId +
          "&tag=" +
          id +
          "&type=" +
          type;
        window.location.href = url;
      },
    );

    // window.location.href =
    //   "/segment-distribution?cid=" +
    //   clientId +
    //   "&tag=" +
    //   id +
    //   "&type=" +
    //   this.state.type;
  }

  renderLeftRailMenu(urlParams) {
    const { segmentDistributionSystems } = this.props;
    delete urlParams["heatmap"];
    return (
      <div className="light-grey-border">
        <div
          style={{
            height: "48px",
            padding: "15px 20px",
            position: "relative",
            background: "#F5F5F5",
          }}
        >
          <strong>Segment Distribution</strong>
        </div>
        {map(segmentDistributionSystems, (sys) => {
          return (
            <div
              key={sys.id}
              onClick={() => {
                if (parseInt(this.state.type, 10) !== sys.id) {
                  this.setState({
                    type: parseInt(sys.id, 10),
                    showEmptyError: false,
                  });
                  urlParams["type"] = parseInt(sys.id);
                  this.props.history.push(
                    (
                      "/segment-distribution" + queryString.stringify(urlParams)
                    ).replace("%3F", "?"),
                  );
                  this.getSegmentDistributionData(undefined, sys.id, undefined);
                  this.props.clearCreateScaleAudienceInfo();
                  this.props.clearCreateVisitorsAudienceInfo();
                }
              }}
              style={{ height: "58px", padding: "15px 20px 15px 35px" }}
              className={
                parseInt(this.state.type, 10) === sys.id ||
                (this.state.type === "default" &&
                  sys.id === segmentDistributionSystems[0].id)
                  ? "distribution-type-active"
                  : "distribution-type"
              }
            >
              {sys.name.split(" ").length > 0 &&
              sys.name.split(" ")[0] !== "Purple" ? (
                <span>
                  {sys.name.split(" ")[0]}
                  <i className="symbol symbol-tm" /> {sys.name.split(" ")[1]}
                </span>
              ) : (
                <span>
                  {sys.name}
                  <i className="symbol symbol-tm" />
                </span>
              )}
            </div>
          );
        })}
      </div>
    );
  }
  getAudienceName(type) {
    const {
      websiteId,
      dayRange,
      client_sites,
      segmentDistributionSystems,
    } = this.props;
    let reportType = "PRIZM Premier";
    const paramType = getUrlParameterByName("type");
    const system = find(segmentDistributionSystems, (s) => {
      return parseInt(s.id, 10) === parseInt(paramType, 10);
    });
    const source = getUrlParameterByName("source");
    const page = getUrlParameterByName("page");
    if (system) reportType = system.name;
    const s = client_sites.find(function (site) {
      return site.value === websiteId;
    });
    let audienceName = s && s.label ? s.label + "_" : "";
    if ((source === "pop" || source === "fav") && page) {
      audienceName += page.replace(/[/. ]/g, "_") + "_";
    }
    if (type === "scale") {
      audienceName += "at_scale_";
    } else {
      audienceName += "website_visitors_";
    }
    audienceName += getDayRangeTitle(dayRange);
    audienceName += "_" + reportType;
    audienceName +=
      this.state.segmentTop === 0
        ? "_allSeg"
        : "_top" + this.state.segmentTop + "Seg";
    audienceName += "_" + moment().format("YYYYMMDD");

    return audienceName.replace(new RegExp(" ", "g"), "_");
  }
  handleAudienceTypeChange(e, value) {
    this.setState({
      audienceName: this.getAudienceName(value),
      audienceType: value,
    });
  }

  granularityChangeHandle() {
    const {
      websiteId,
      dayRange,
      segmentDistributionHouseHold,
      granularity,
    } = this.props;
    const { type, measure, segmentTop } = this.state;
    const page = getUrlParameterByName("page");
    const tagId = this.getTagId();
    const heatmap = getUrlParameterByName("heatmap");
    const segmentIds = map(
      sortBy(segmentDistributionHouseHold.distributions, (d) => {
        if (measure === "index") return d.segmentIndex;
        else
          return (
            d.householdVisitors /
            segmentDistributionHouseHold.totalHouseholdVisitors
          );
      }),
      "segmentCode",
    )
      .reverse()
      .slice(0, segmentTop)
      .join(",");
    this.props.getSegmentDistributionDetailReport(
      tagId || websiteId,
      type,
      dayRange,
      undefined,
      page,
      granularity,
    );

    if (!heatmap) {
      this.props.getCultureCodeReport(
        tagId,
        type,
        dayRange,
        segmentIds,
        page,
        granularity,
      );
    } else {
      this.props.getDistributionHeatMapData(
        tagId,
        type,
        dayRange,
        segmentIds,
        page,
        granularity,
      );
    }
  }

  render() {
    const {
      websiteId,
      setDateRange,
      dayRange,
      granularity,
      setGranularity,
      client_sites,
      savingScaleAudience,
      savingScaleAudienceResult,
      savingScaleAudienceError,
      savingVisitorsAudienceResult,
      savingVisitorsAudienceError,
      savingVisitorsAudience,
      segmentDistributionHouseHold,
      segmentDistributionSystems,
    } = this.props;
    const tagId = this.getTagId();
    const clientId = getUrlParameterByName("cid")
      ? parseInt(getUrlParameterByName("cid"), 10)
      : this.props.websiteId;

    const page = getUrlParameterByName("page");
    const type = getUrlParameterByName("type");
    const urlParams = queryString.parse(this.props.location.search);
    const topCountTitle =
      this.state.segmentTop === 0 ? "All " : `Top ${this.state.segmentTop} `;
    const heatmap = getUrlParameterByName("heatmap");
    const source = getUrlParameterByName("source");
    const randomStr = new Date().getTime();
    const heatMapData = [];
    if (heatmap) {
      map(this.props.distributionHeatmapData, (point) => {
        heatMapData.push({
          position: [point.lon, point.lat],
          weight: parseInt(point.u, 10),
        });
      });
    }
    return (
      <div id="segment-distribution-container">
        <div
          style={{
            margin: "-20px 10% 0px",
            fontSize: "16px",
          }}
        >
          {this.showPageNavigation(urlParams)}
          <SiteDateSelector
            type={"larger"}
            key={"segment-distribution-site-selector-" + new Date().getTime()}
            websiteIdChanged={
              page ? undefined : this.onWebSiteIdChanged.bind(this)
            }
            siteId={tagId ? tagId : websiteId}
            sites={client_sites}
            dayRangeChanged={setDateRange}
            dayRange={
              dayRange
            } /*
            granularity={granularity}
            granularityChanged={setGranularity}*/
            handlePdfDownload={
              heatmap ? null : () => this.setState({ showDownloadDialog: true })
            }
            handleSegmentCreation={
              segmentDistributionHouseHold &&
              !isEmpty(segmentDistributionHouseHold.distributions) &&
              !this.state.showEmptyError
                ? tagId && !heatmap
                  ? () => {
                      this.setState({
                        audienceName: this.getAudienceName(
                          this.state.audienceType,
                        ),
                        showCreateAudienceDialog: true,
                      });
                    }
                  : null
                : null
            }
            downloadBtnText={heatmap ? null : "Download Report"}
          />
        </div>
        {/*<div className="" style={{
          padding: '15px 10% 25px',
          borderTop: '1px solid #EEEFF2',
          borderBottom: '1px solid #EEEFF2',
          fontSize: "16px",
        }}>
          <DateGranularitySelector
            dayRangeChanged={this.props.setDateRange}
            dayRange={this.props.dayRange}
            granularity={this.state.granularity}
            granularityChanged={(val) => {
              this.setState({
                granularity: val,
              }, () => {
                window.localStorage.setItem('__granularity__', val);
                this.granularityChangeHandle();
              });
            }}
            />
        </div>*/}
        <div style={{ display: "flex", padding: "10px 10%", fontSize: "16px" }}>
          <div id="left-nav" style={{ flex: "0 0 220px" }}>
            {this.renderLeftRailMenu(urlParams)}
            <div className="light-grey-border mt-20">
              <div
                style={{
                  height: "48px",
                  padding: "15px 20px",
                  position: "relative",
                  background: "#F5F5F5",
                }}
              >
                <strong>Page Insights</strong>
              </div>
              <div
                onClick={() => {
                  type
                    ? this.props.history.push(
                        "/distribution/pages/popular?tag=" +
                          tagId +
                          "&cid=" +
                          clientId +
                          "&type=" +
                          type,
                      )
                    : this.props.history.push(
                        "/distribution/pages/popular?tag=" +
                          tagId +
                          "&cid=" +
                          clientId,
                      );
                }}
                style={{ height: "58px", padding: "15px 20px 15px 35px" }}
                className="distribution-type"
              >
                Most Popular Pages
              </div>
              <div
                onClick={() => {
                  type
                    ? this.props.history.push(
                        "/distribution/pages/favorite?tag=" +
                          tagId +
                          "&cid=" +
                          clientId +
                          "&type=" +
                          type,
                      )
                    : this.props.history.push(
                        "/distribution/pages/favorite?tag=" +
                          tagId +
                          "&cid=" +
                          clientId,
                      );
                }}
                style={{ height: "58px", padding: "15px 20px 15px 35px" }}
                className="distribution-type"
              >
                Favorite Pages
              </div>
            </div>
          </div>
          {this.props.segmentDistributionHouseHold &&
          !isEmpty(this.props.segmentDistributionHouseHold.distributions) ? (
            <div
              id="report-main"
              className="ml-20"
              style={{ width: "100%", flex: "1 0" }}
            >
              <div
                className="light-grey-border text-center p-10"
                id="contact-div"
              >
                <small
                  onClick={() => {
                    this.setState({ openContactUs: true });
                  }}
                  className="link"
                >
                  Click here
                </small>{" "}
                to engage and activate these audiences across online and offline
                channels.
              </div>
              <div className="mt-20">
                {this.props.segmentDistributionHouseHold && (
                  <SegmentHousehold
                    data={this.props.segmentDistributionHouseHold.distributions}
                    systems={this.props.segmentDistributionSystems}
                    totalHouseholdVisitors={
                      this.props.segmentDistributionHouseHold
                        .totalHouseholdVisitors
                    }
                    totalVisits={
                      this.props.segmentDistributionHouseHold.totalVisits
                    }
                    zip9Households={
                      this.props.segmentDistributionHouseHold.zip9Households
                    }
                    zip11Households={
                      this.props.segmentDistributionHouseHold.zip11Households
                    }
                    type={this.state.type}
                    measure={this.state.measure}
                    topCount={this.state.segmentTop}
                    changeMeasure={this.changeMeasure.bind(this)}
                    changeTopCount={this.changeTopCount.bind(this)}
                  />
                )}
              </div>
              {heatmap && (
                <HeatMap
                  key={"overview-geographic-" + randomStr}
                  width={960}
                  height={600}
                  title="Geographic Traffic"
                  data={null}
                  onLoading={this.props.distributionHeatmapLoading}
                  pointsData={heatMapData}
                />
              )}
              {!heatmap && (
                <div className="mt-20">
                  {this.props.loadingSegmentDistribution && (
                    <div
                      className="text-center"
                      style={{ height: "350px", marginTop: "120px" }}
                    >
                      <img
                        alt=""
                        src="/Spinner.gif"
                        style={{ height: "48px" }}
                      />
                    </div>
                  )}
                  {this.props.segmentDistributionHouseHold && (
                    <HighestOpportunityAudience
                      orderType={this.state.measure}
                      type={
                        this.state.type === "default"
                          ? getUrlParameterByName("type")
                          : this.state.type
                      }
                      systems={this.props.segmentDistributionSystems}
                      data={
                        this.props.segmentDistributionHouseHold.distributions
                      }
                      total={
                        this.props.segmentDistributionHouseHold
                          .totalHouseholdVisitors
                      }
                      topCount={this.state.segmentTop}
                      printMode={this.state.printMode}
                    />
                  )}
                </div>
              )}
              <div
                className="mt-20 light-grey-border-bottom top-navigator"
                style={{
                  display: heatmap ? "none" : "flex",
                  fontSize: "16px",
                }}
              >
                <div
                  className={
                    this.state.ppType == "detail"
                      ? "light-grey-border prizm-premier-active"
                      : "light-grey-border prizm-premier-inactive"
                  }
                  onClick={() => {
                    this.setState({ ppType: "detail" });
                  }}
                  style={{ width: "auto" }}
                >
                  {this.getTabTitleContent("Segment", topCountTitle)}
                </div>
                <div
                  className={
                    this.state.ppType == "device"
                      ? "light-grey-border prizm-premier-active"
                      : "light-grey-border prizm-premier-inactive"
                  }
                  onClick={() => {
                    this.setState({ ppType: "device" });
                  }}
                  style={{ width: "auto" }}
                >
                  {this.getTabTitleContent("Device", topCountTitle)}
                </div>
                <div
                  className={
                    this.state.ppType == "culture"
                      ? "light-grey-border prizm-premier-active"
                      : "light-grey-border prizm-premier-inactive"
                  }
                  onClick={() => {
                    {
                      /*this.getCultureReport();*/
                    }
                    this.setState({
                      ppType: "culture",
                    });
                  }}
                  style={{ width: "auto" }}
                >
                  Culture Codes
                </div>
              </div>
              {heatmap
                ? []
                : [
                    <SegmentDetailReport key="segment-detail-report"
                      style={{
                        display:
                          this.state.ppType === "detail" ? "flex" : "none",
                        fontSize: "16px",
                        marginTop: "20px",
                        minWidth: "440px",
                        minHeight: "400px",
                      }}
                      printTitle={this.getTabTitleContent(
                        "Segment",
                        topCountTitle,
                      )}
                      data={this.props.detailDistributionReport}
                      loading={this.props.loadingDistributionDetailReport}
                    />,
                    <SegmentDeviceReport key="segment-device-report"
                      printTitle={this.getTabTitleContent(
                        "Device",
                        topCountTitle,
                      )}
                      top5OSBreakDown={this.props.top5OSBreakDown}
                      loadingTop5OSBreakdown={this.props.loadingTop5OSBreakdown}
                      deviceModelData={this.props.deviceModelReport}
                      loadDeviceModelReport={this.props.loadDeviceModelReport}
                      deviceTypeData={this.props.deviceTypeReport}
                      loadDeviceTypeReport={this.props.loadDeviceTypeReport}
                      style={{
                        display:
                          this.state.ppType === "device" ? "flex" : "none",
                        fontSize: "16px",
                        marginTop: "20px",
                        width: "100%",
                        minWidth: "440px",
                        minHeight: "400px",
                      }}
                    />,
                    <SegmentCultureReport key="segment-culture-report"
                      style={{
                        display:
                          this.state.ppType === "culture" ? "flex" : "none",
                      }}
                      data={this.props.cultureCodeReport}
                      onPdfReportDownload={this.state.onPdfReportDownload}
                    />,
                  ]}
            </div>
          ) : (
            <div
              id="report-main"
              className="ml-20"
              style={{ width: "100%", flex: "1 0" }}
            >
              {this.state.showEmptyError === true || !tagId ? (
                <div
                  className="light-grey-border text-center p-10"
                  id="contact-div"
                  style={{ color: "#DD0000" }}
                >
                  <AlertError
                    style={{
                      fill: "#DD0000",
                      width: "16px",
                      height: "16px",
                    }}
                  />{" "}
                  {"No data to display try a different date range"}
                </div>
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "24px",
                    marginTop: "50px",
                  }}
                >
                  Page loading...{" "}
                  <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
                </div>
              )}
            </div>
          )}
        </div>

        <Dialog
          title={"Contact Us"}
          modal={false}
          autoDetectWindowHeight={false}
          autoScrollBodyContent={true}
          titleStyle={{ fontWeight: "bold", fontSize: "24px", padding: "20px" }}
          open={this.state.openContactUs}
          onRequestClose={() => {
            this.setState({ openContactUs: false });
          }}
          bodyStyle={{
            color: "#000",
            fontWeight: "normal",
            fontSize: "16px",
            paddingTop: "0px",
            paddingBottom: "20px",
            textAlign: "left",
            overflowY: "auto",
            height: "1080px",
            borderTop: "solid 0px #EEEFF2",
          }}
          contentStyle={{
            width: "960px",
            maxWidth: "960px",
            height: "1080px",
          }}
        >
          <div>
            <div
              style={{
                paddingBottom: "20px",
                marginBottom: "20px",
                borderBottom: "solid 1px #EEEFF2",
              }}
            >
              Claritas can help you activate and target your audiences across
              both offline and online channels. We offer multiple delivery paths
              to support your business needs:
            </div>
            <div className="pt-20" style={{ display: "flex" }}>
              <div style={{ width: "280px", borderRight: "solid 1px #EEEFF2" }}>
                <div>
                  <strong>Claritas Full Campaign Execution</strong>
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ padding: " 20px 10px 20px 0px" }}>
                    <img src="/images/claritas-email-logo.png" />
                    <div className="pt-10 text-center">
                      <strong>Email</strong>
                    </div>
                  </div>
                  <div style={{ padding: " 20px 10px 0px" }}>
                    <img src="/images/claritas-social-logo.png" />
                    <div className="pt-10 text-center">
                      <strong>Social</strong>
                    </div>
                  </div>
                  <div style={{ padding: " 20px 0px 20px 10px" }}>
                    <img src="/images/claritas-display-logo.png" />
                    <div className="pt-10 text-center">
                      <strong>Display</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ width: "600px", marginLeft: "20px" }}>
                <div className="text-center">
                  <strong>
                    Claritas can provide audiences for campaign execution:
                  </strong>
                </div>
                <div
                  style={{
                    borderBottom: "solid 1px #EEEFF2",
                    paddingBottom: "20px",
                    paddingTop: "20px",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "75px" }}>
                    <strong>Email - </strong>
                  </div>
                  <div>
                    Under certain circumstances, we will deliver active email
                    addresses for campaign execution
                  </div>
                </div>
                <div
                  style={{
                    borderBottom: "solid 1px #EEEFF2",
                    paddingBottom: "20px",
                    paddingTop: "20px",
                  }}
                >
                  <strong>Social - </strong> We onboard audiences to your social
                  platform of choice
                </div>
                <div
                  style={{
                    borderBottom: "solid 1px #EEEFF2",
                    paddingBottom: "20px",
                    paddingTop: "20px",
                  }}
                >
                  <strong>Display - </strong> We deliver audiences to your
                  platform of choice for programmatic buying
                </div>
                <div
                  style={{
                    paddingBottom: "20px",
                    paddingTop: "20px",
                  }}
                >
                  <strong>Direct Mail - </strong> We deliver full name and
                  postal addresses of your audience
                </div>
              </div>
            </div>
            <div
              style={{
                marginTop: "20px",
                marginBottom: "20px",
                paddingTop: "20px",
                paddingBottom: "20px",
                borderTop: "solid 1px #EEEFF2",
                textAlign: "center",
              }}
            >
              Find PRIZM® Premier, P$YCLE® Premier, and ConneXions® segments
              available today across our vast digital partner network:
            </div>
            <div style={{ display: "flex", marginTop: "40px" }}>
              <div style={{ width: "150px" }}>&nbsp;</div>
              <div style={{ width: "180px" }}>
                <img src="/images/liveRamp-logo.png" />
              </div>
              <div style={{ width: "160px" }}>
                <img src="/images/google-logo.png" />
              </div>
              <div style={{ width: "140px" }}>
                <img src="/images/oauth-logo.png" />
              </div>
              <div style={{ width: "150px" }}>
                <img src="/images/adobe-logo.png" />
              </div>
              <div style={{ width: "10%" }}>&nbsp;</div>
            </div>
            <div
              style={{
                display: "flex",
                marginTop: "40px",
                paddingBottom: "20px",
                borderBottom: "solid 1px #EEEFF2",
              }}
            >
              <div style={{ width: "180px" }}>&nbsp;</div>
              <div style={{ width: "250px" }}>
                <img src="/images/theTradeDesk-logo.png" />
              </div>
              <div style={{ width: "170px", marginTop: "-10px" }}>
                <img src="/images/mediaMath-logo.png" />
              </div>
              <div style={{ width: "150px" }}>
                <img src="/images/oracle-logo.png" />
              </div>
              <div style={{ width: "10%" }}>&nbsp;</div>
            </div>
            <div style={{ padding: "20px 0 0" }}>
              <div className="text-center">
                <strong>Contact us to discuss options and next steps</strong>
              </div>
              <div style={{ display: "flex", padding: "20px 0" }}>
                <div style={{ width: "100px" }}>
                  <strong>Subject</strong>
                </div>
                <div style={{ width: "780px" }}>
                  <input
                    type="text"
                    style={{
                      width: "100%",
                      border: "solid 1px",
                      padding: "10px",
                    }}
                    value={this.state.subject}
                    maxLength="65"
                    onChange={(e) => {
                      this.setState({ subject: e.target.value });
                    }}
                  />
                </div>
              </div>
              <div style={{ display: "flex", padding: "10px 0 20px" }}>
                <div style={{ width: "100px" }}>
                  <strong>Comments</strong>
                </div>
                <div style={{ width: "780px" }}>
                  <textarea
                    className="comment-box"
                    rows="6"
                    style={{
                      width: "100%",
                      padding: "10px",
                      overflowY: "auto",
                    }}
                    value={this.state.comments}
                    maxLength="500"
                    onChange={(e) => {
                      this.setState({ comments: e.target.value });
                    }}
                  />
                </div>
              </div>
            </div>
            <div style={{ textAlign: "right" }}>
              {this.props.send_assist_request_error && (
                <div
                  className="pull-left ml-20 mt-5"
                  style={{ fontWeight: "bold", color: "#FF0000" }}
                >
                  {this.props.send_assist_request_error}
                </div>
              )}

              <button
                className="btn "
                onClick={() => {
                  this.setState({ openContactUs: false });
                }}
              >
                Cancel
              </button>
              <button
                disabled={
                  isEmpty(this.state.comments) || isEmpty(this.state.subject)
                }
                className="btn btn-claritas-default ml-20"
                onClick={(e) => {
                  this.submitContactRequest(e);
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </Dialog>
        <Dialog
          open={this.state.showSuccessForm}
          onRequestClose={() => {
            this.setState({ showSuccessForm: false });
          }}
          contentStyle={{ width: "350px", padding: "20px" }}
          modal={true}
        >
          <div
            style={{ fontSize: "16px", fontFamily: "Arial", color: "#000" }}
            className="text-center"
          >
            Your message has been sent.
          </div>
          <div
            style={{ fontSize: "15px", fontFamily: "Arial", color: "#000" }}
            className="text-center mt-10"
          >
            Your client services representative will contact you within one
            business day.
          </div>
          <div className="text-center mt-20">
            <button
              className="btn btn-aa-default"
              onClick={() => {
                this.setState({ showSuccessForm: false });
              }}
            >
              CLOSE
            </button>
          </div>
        </Dialog>
        <Dialog
          open={this.state.onPdfReportDownload}
          style={{ top: "-1.8em" }}
          modal={true}
          contentStyle={{ width: "500px" }}
          overlayStyle={{ opacity: 0.9, backgroundColor: "#666666" }}
        >
          <Row className="mt-20">
            <Col
              offsetXs="1"
              offsetSm="1"
              offsetMd="1"
              offsetLg="1"
              xs="7"
              sm="7"
              md="7"
              lg="7"
              className="text-right"
            >
              <div>{"Downloading, please wait..."}</div>
            </Col>
            <Col xs="1" sm="1" md="1" lg="1">
              <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
            </Col>
          </Row>
        </Dialog>
        <Dialog
          open={this.state.showCreateAudienceDialog}
          style={{ top: "-1.8em" }}
          modal={true}
          contentStyle={{ width: "460px" }}
        >
          <div
            style={{ display: savingVisitorsAudienceResult ? "block" : "none" }}
          >
            <FullRow
              className="no-margin-top no-padding  text-center"
              style={{ fontSize: "16px", color: "#000" }}
            >
              <strong>Your audience segment has been saved.</strong>
            </FullRow>
            <FullRow
              className="pt-10 no-padding-bottom no-padding-right pl-10"
              style={{ color: "#000" }}
            >
              The file is being processed and will be available in the{" "}
              <span
                className="nav-clickable"
                onClick={() => {
                  this.props.history.push(
                    "/segments/list/active?cid=" + this.props.selected_client,
                  );
                }}
              >
                audience library
              </span>{" "}
              when it is ready.
            </FullRow>
            <FullRow className="text-center no-padding-bottom no-margin-bottom">
              <button
                type="button"
                className="btn btn-default btn-aa-default"
                onClick={() => {
                  this.props.clearCreateScaleAudienceInfo();
                  this.props.clearCreateVisitorsAudienceInfo();
                  this.setState({
                    showCreateAudienceDialog: false,
                    audienceName: "",
                  });
                }}
              >
                Close
              </button>
            </FullRow>
          </div>
          <div
            style={{ display: savingScaleAudienceResult ? "block" : "none" }}
          >
            <FullRow
              className="no-margin-top no-padding  text-center"
              style={{ fontSize: "16px", color: "#000" }}
            >
              <strong>Your audience segment has been saved.</strong>
            </FullRow>
            <FullRow
              className="pt-10 no-padding-bottom no-padding-right pl-10"
              style={{ color: "#000" }}
            >
              <div className="mb-20">
                <CheckCircle
                  style={{ width: "20px", height: "20px", color: "#347eb0" }}
                />
                {"   "}It has been added to your{" "}
                <span
                  className="nav-clickable"
                  onClick={() => {
                    this.props.history.push(
                      "/segments/list/active?cid=" + this.props.selected_client,
                    );
                  }}
                >
                  audience library
                </span>
              </div>
              <div>
                <CheckCircle
                  style={{ width: "20px", height: "20px", color: "#347eb0" }}
                />
                {"   "}View attribute breakdown in your{" "}
                <span
                  className="nav-clickable"
                  onClick={() => {
                    this.props.history.push(
                      "/segments/list/detail/" + savingScaleAudienceResult.id,
                    );
                  }}
                >
                  audience details
                </span>
              </div>
            </FullRow>
            <FullRow className="text-center no-padding-bottom no-margin-bottom">
              <button
                type="button"
                className="btn btn-default btn-aa-default"
                onClick={() => {
                  this.props.clearCreateScaleAudienceInfo();
                  this.props.clearCreateVisitorsAudienceInfo();
                  this.setState({
                    showCreateAudienceDialog: false,
                    audienceName: "",
                  });
                }}
              >
                Close
              </button>
            </FullRow>
          </div>
          <div
            style={{
              display:
                savingScaleAudienceResult || savingVisitorsAudienceResult
                  ? "none"
                  : "block",
            }}
          >
            <FullRow
              className="no-margin-top no-padding"
              style={{ fontSize: "16px", color: "#000" }}
            >
              <strong>
                Choose the type of audience you would like to save.
              </strong>
            </FullRow>
            <FullRow>
              <RadioButtonGroup
                style={{ paddingLeft: "50px" }}
                name="createAudienceType"
                valueSelected={this.state.audienceType}
                onChange={this.handleAudienceTypeChange.bind(this)}
              >
                <RadioButton
                  value={"visitor"}
                  label="Save audience from website visitors"
                  iconStyle={{ fill: "black", width: "20px", height: "20px" }}
                />
                <RadioButton
                  value={"scale"}
                  label="Create a target audience at scale"
                  iconStyle={{ fill: "black", width: "20px", height: "20px" }}
                />
              </RadioButtonGroup>
              <div
                className="light-grey-bottom-border mb-20"
                style={{ marginTop: "-10px" }}
              >
                &nbsp;
              </div>
              <div style={{ color: "#000" }}>
                <span className="mr-20">
                  <strong>Name</strong>
                </span>
                <TextField
                  underlineShow={false}
                  className="light-grey-border pl-10 pr-10"
                  style={{ width: "305px" }}
                  maxLength={100}
                  value={this.state.audienceName}
                  onChange={(e, newVal) => {
                    this.setState({ audienceName: newVal });
                  }}
                />
              </div>
            </FullRow>
            {savingScaleAudienceError && (
              <FullRow className="no-padding-top no-padding-bottom no-margin-bottom">
                <div style={{ color: "red" }}>
                  {savingScaleAudienceError.message}
                </div>
              </FullRow>
            )}
            {savingVisitorsAudienceError && (
              <FullRow className="no-padding-top no-padding-bottom no-margin-bottom">
                <div style={{ color: "red" }}>
                  {savingVisitorsAudienceError.message}
                </div>
              </FullRow>
            )}
            <FullRow className="no-padding-bottom no-margin-bottom no-padding-top">
              {(savingScaleAudience || savingVisitorsAudience) && (
                <img
                  alt=""
                  src="/Spinner.gif"
                  style={{ height: "24px", float: "left" }}
                />
              )}
              <button
                type="button"
                className="btn btn-default btn-aa-default pull-right"
                disabled={isEmpty(this.state.audienceName)}
                onClick={() => {
                  this.saveAudience();
                }}
              >
                Save
              </button>
              <button
                type="button"
                className="pull-right btn btn-aa-info mr-10"
                onClick={() => {
                  this.setState({
                    showCreateAudienceDialog: false,
                    audienceName: "",
                  });
                }}
              >
                Cancel
              </button>
            </FullRow>
          </div>
        </Dialog>
        <Dialog
          open={this.state.showDownloadDialog}
          style={{ top: "-1.8em" }}
          modal={true}
          contentStyle={{ width: "440px" }}
        >
          <FullRow
            className="no-margin-top no-padding"
            style={{ fontSize: "16px", color: "#000" }}
          >
            <strong>Choose the type of file you would like to download</strong>
          </FullRow>
          <FullRow
            className="no-padding-top no-padding-right no-padding-bottom no-margin-bottom"
            style={{ paddingLeft: "150px" }}
          >
            <Checkbox
              iconStyle={{ fill: "#47A1AB", marginRight: "10px" }}
              label={"PDF File"}
              labelStyle={{ fontSize: "13px" }}
              defaultChecked={true}
              ref="cbPDF"
              onCheck={(e, isInputChecked) =>
                this.cbPDFChange(e, isInputChecked)
              }
            />
          </FullRow>
          <FullRow
            className="no-padding-top no-padding-right no-padding-bottom"
            style={{ paddingLeft: "150px" }}
          >
            <Checkbox
              iconStyle={{ fill: "#47A1AB", marginRight: "10px" }}
              label={"CSV File"}
              labelStyle={{ fontSize: "13px" }}
              defaultChecked={false}
              ref="cbCSV"
              onCheck={(e, isInputChecked) =>
                this.cbCSVChange(e, isInputChecked)
              }
            />
          </FullRow>
          <FullRow className="no-padding no-margin-bottom mt-20 text-center">
            <button
              type="button"
              onClick={() => this.setState({ showDownloadDialog: false })}
              className="btn btn-default btn-aa-info mr-20"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={this.handleDownload.bind(this)}
              disabled={
                this.state.disabledBtnDownload ||
                !this.props.detailDistributionReport
              }
              className="btn btn-default btn-aa-default"
            >
              Download File
            </button>
          </FullRow>
        </Dialog>
      </div>
    );
  }
}

export default SegmentDistribution;



// WEBPACK FOOTER //
// ./src/components/Insights/distribution/index.jsx